import { useOffline } from "../lib/offline-context.js";
import type { SyncError } from "../lib/offline-context.js";

const KIND_LABELS_FR: Record<SyncError["kind"], string> = {
  accept: "Accepter",
  refuse: "Refuser",
  start: "Démarrer",
  update_render: "Enregistrer le rendu",
  register_media: "Ajouter un média",
  remove_media: "Supprimer un média",
  submit: "Soumettre",
  resume: "Reprendre",
};

function formatReason(e: SyncError): string {
  if (e.status === "conflict") return `Conflit : ${e.reason}`;
  return e.reason || "Action refusée par le serveur";
}

export function SyncErrorToasts() {
  const { syncErrors, dismissSyncError } = useOffline();
  if (syncErrors.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 max-w-sm">
      {syncErrors.map((e) => (
        <div
          key={e.id}
          role="alert"
          className="rounded-md border border-red-300 bg-red-50 text-red-900 shadow-md px-3 py-2 text-sm"
        >
          <div className="flex items-start gap-2">
            <div className="flex-1 min-w-0">
              <div className="font-medium">
                {KIND_LABELS_FR[e.kind] ?? e.kind} — refusé
              </div>
              <div className="text-xs mt-0.5 break-words">{formatReason(e)}</div>
            </div>
            <button
              onClick={() => dismissSyncError(e.id)}
              className="text-red-700 hover:text-red-900 text-xs px-1"
              aria-label="Fermer"
            >
              ✕
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
